import { useGetTransactionReports } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function TransactionReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:transaction_report')}
      usePivotQuery={useGetTransactionReports}
      isShowAllFilterCompleted
    />
  );
}
